<template>
  <div class="tw-px-6 tw-py-3">
    <div class="tw-flex tw-items-center tw-gap-3 tw-mb-2">
      <span
        class="tw-font-bold tw-text-xl tw-whitespace-nowrap"
        :class="isIntroLike ? 'tw-text-progress' : 'tw-text-progress tw-opacity-40'"
      >
        Intro
      </span>
      <span class="tw-text-progress tw-font-bold tw-text-xl tw-whitespace-nowrap">
        {{ currentQuestion }}/{{ totalQuestions }}
      </span>
    </div>
    <div class="tw-flex tw-gap-1 tw-flex-1">
      <div
        v-for="i in totalSegments"
        :key="i"
        class="tw-h-1 tw-flex-1 tw-rounded-sm"
        :class="segmentClass(i)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleProgressBar',
  methods: {
    segmentClass(i) {
      if (i === this.filledSegments) return 'tw-bg-segment-active';
      if (i < this.filledSegments) return 'tw-bg-segment-active tw-opacity-40';
      return 'tw-bg-segment-inactive';
    },
  },
  computed: {
    currentModule() {
      return this.$store.getters['exam/currentModule'];
    },
    currentQuestionIndex() {
      return this.$store.state.exam.current.question;
    },
    isIntro() {
      return this.currentQuestionIndex === null;
    },
    isPreQuestionIntro() {
      return this.currentQuestionIndex === -1;
    },
    isIntroLike() {
      return this.isIntro || this.isPreQuestionIntro;
    },
    totalQuestions() {
      return this.currentModule?.questions?.length || 0;
    },
    currentQuestion() {
      return this.currentQuestionIndex !== null && this.currentQuestionIndex >= 0 ? this.currentQuestionIndex + 1 : 0;
    },
    totalSegments() {
      return this.totalQuestions + 1;
    },
    filledSegments() {
      if (this.isIntroLike) return 1;
      return this.currentQuestionIndex + 2;
    },
  },
};
</script>
